module.exports = __webpack_public_path__ + "img/thinking_grandma.c56822a5.svg";